import { Button, Typography } from "@mui/material";
import UISwipeableDrawer from "components/drawers/SwipeableDrawer";
import SupportCard from "components/wrapper_v2/SupportCard";
import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setConsent } from "redux/actions/Consent";
import { set_show_popup } from "redux/actions/ScribeAcitons";
import {
  leftPanelReset,
  rightPanelReset,
} from "redux/reducers/EncounterResetSlice";
import {
  setCannyLoading,
  setCannyDialogOpen,
  setCannyToken,
  resetCannyState,
} from "redux/reducers/CannySlice";
import { HTTPAidaBaseService } from "adapters/http";
import { getTenantFromToken } from "config/helpers/common_helper";
import { toast } from "react-toastify";

const Available247 = () => {
  const { i18n } = useTranslation();
  const [isSupportDrawerOpen, setIsSupportDrawerOpen] = useState(false);

  const isRecording = useSelector((state) => state?.recognizer?.recording);
  const isPaused = useSelector((state) => state?.recognizer?.paused);
  const currentUser = useSelector((state) => state?.auth?.userData?.resource);
  const reduxDispatch = useDispatch();
  const tenantID = getTenantFromToken();

  const cannyUser = useMemo(
    () =>
      currentUser
        ? { id: tenantID, name: currentUser.name, email: currentUser.email }
        : null,
    [currentUser, tenantID],
  );

  const handleCannyWidget = async () => {
    if (!cannyUser) return toast.warn("User information not available");

    reduxDispatch(setCannyLoading(true));

    try {
      const { data } = await HTTPAidaBaseService.get(
        `/canny/${tenantID}/generate-sso`,
      );

      if (data?.ssoToken) {
        reduxDispatch(setCannyToken(data.ssoToken));
        reduxDispatch(setCannyDialogOpen(true));
      } else {
        toast.error(i18n.t("error_messages.CANNY_TOAST_ERROR"));
        reduxDispatch(resetCannyState());
      }
    } catch (error) {
      console.error("Failed to fetch Canny SSO token:", error);
      toast.error("Failed to load feature request widget");
      reduxDispatch(resetCannyState());
    }
  };

  return (
    <>
      <UISwipeableDrawer
        open={isSupportDrawerOpen}
        setOpen={setIsSupportDrawerOpen}
        appBar={false}
        width="clamp(40vh,40%,60vw)"
        jsx={
          <SupportCard
            handleClose={() => setIsSupportDrawerOpen(false)}
            onOpenCanny={handleCannyWidget}
          />
        }
      />
      <Button
        sx={styles.button}
        variant="outlined"
        onClick={() => {
          if (isRecording || isPaused) {
            reduxDispatch(
              set_show_popup(true, () => {
                // reduxDispatch(leftPanelReset());
                reduxDispatch(rightPanelReset());
                reduxDispatch(setConsent(false));
                setIsSupportDrawerOpen(true);
              }),
            );
          } else {
            setIsSupportDrawerOpen(true);
          }
        }}
      >
        <Typography sx={{ fontSize: "clamp(0.8vh, 0.8vw, 0.8vw)" }}>
          {i18n.t("common.Help")}
        </Typography>
      </Button>
    </>
  );
};

const styles = {
  button: {
    padding: "0.3vw 0.5vw",
    color: "#fff",
    background:
      "linear-gradient(90deg, rgba(43, 44, 119, 0.5) 47.31%, rgba(188, 184, 184, 0.5) 129.24%)",
    textTransform: "none",
    borderRadius: "2vw",
  },
};

export default Available247;
